import JEN_HowSFWork_Animation from '@/assets/animation/JEN_HowSFWork-Animation_Web--v04.json';
import { WaveformIcon } from '@/components/Icons';
import { Button } from '@/components/ui/button';
import Lottie from 'lottie-react';

export default function MarketHeader({ trackListRef }: { trackListRef: React.RefObject<HTMLDivElement> }) {
  return (
    <div className="w-full flex justify-between lg:flex-row gap-24 items-center">
      {/* Left Column */}
      <div className="space-y-6">
        <h1>
          <span className="block text-[2rem] text-jen-orange font-normal leading-[32px] tracking-[-1.28px]">
            StyleFilter™ Marketplace.
          </span>
          <span className="block text-[2rem] font-normal leading-[32px] tracking-[-1.28px]">
            A patented groundbreaking
            <br />
            tool in music creation.
          </span>
        </h1>
        <div className="flex gap-3">
          <Button
            size="lg"
            variant="default"
            className="!px-[18px] !py-[14px] !bg-[#FF5b27] !text-white hover:!bg-[#FF5b27]/80 !text-[1rem] !tracking-[-3%]"
            onClick={() => {
              window.open('https://jenmusic.ai/stylefilters', '_blank');
            }}
          >
            What is a StyleFilter™?
          </Button>
          <Button
            variant="outline"
            size="lg"
            className="border-1 text-[#48484B] border-[#CECFD3] !px-[18px] !py-[14px] tracking-[-3%]"
            onClick={() => {
              if (trackListRef.current) {
                trackListRef.current.scrollIntoView({ behavior: 'smooth' });
              }
            }}
          >
            <WaveformIcon className="mr-2 h-4 w-4" />
            Jenerated Tracks
          </Button>
        </div>
      </div>

      {/* Right Column */}
      <div className="space-y-4">
        <div className="w-full max-w-3xl mx-auto p-4 bg-[#fff] rounded-3xl">
          <div className="flex items-center justify-between">
            <h2 className="font-medium tracking-[-0.32px]">How StyleFilters™ Work</h2>
            <Button
              variant="link"
              onClick={() => {
                window.open('https://jenmusic.ai/stylefilters', '_blank');
              }}
            >
              <span className="text-[#9D9DA6] hover:text-gray-700 underline tracking-[-0.32px]">Learn More</span>
            </Button>
          </div>

          <div className="h-auto w-[400px] mt-4">
            <Lottie animationData={JEN_HowSFWork_Animation} className="" />
          </div>
        </div>
      </div>
    </div>
  );
}
